import React, { FC } from "react";
import Paragraph, { ParagraphProps } from "../Paragraph";

const P2: FC<ParagraphProps> = (props) => <Paragraph {...props} size="small" />;

export default P2;
